import * as React from "react";

import styles from "./AppLoader.module.scss";

export const AppLoader: React.FC = () => {
  return (
    <div className={styles.loader}>
      <img
        width={100}
        height={100}
        src={require("assets/images/gif/loader.gif")}
        alt=""
      />
    </div>
  );
};
